/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
/* eslint jsx-a11y/no-noninteractive-element-interactions: 0 */
/* eslint jsx-a11y/aria-role: 0 */
import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isMobile, isTablet } from 'react-device-detect';
import Nav from '../../components/Nav';
import MobileNavButton from '../../components/MobileNavButton';
import EmailCaptureCloud from '../../components/EmailCapture/EmailCaptureCloud';
import Footer from '../../components/Footer';
import styles from './navExpander.css';

const NavExpander = ({
  children,
  disable,
  history,
  location,
  isInspirationGallery,
  hideFooter,
  footerColor,
}) => {
  const [contentTop, setContentTop] = useState(0);
  const [navActive, setNavActive] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [showForm, setShowForm] = useState(true);
  const footerRef = useRef(null);

  const defaultStyle = {
    '--content-top': `${contentTop}px`,
    top: contentTop,
  };

  const activeStyle = {
    height: `calc(100vh - ${contentTop}px)`,
    transform: `translateY(${navHeight - contentTop}px)`,
  };

  const notActiveStyle = {
    height: `calc(100vh - ${contentTop}px)`,
    transform: 'translateY(0)',
  };

  const currentStyle = navActive ? activeStyle : notActiveStyle;
  const isTouch = isMobile || isTablet;

  const emailCloudBlockList = ['/', '/inspiration-gallery'];

  useEffect(() => {
    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }

    setShowForm(localStorage.getItem('emailFormState') !== 'closed' && !emailCloudBlockList.includes(location.pathname));
  }, []);

  const setPosition = (top, height) => {
    setContentTop(top);
    setNavHeight(height);
  };

  const handleAction = (value, type) => {
    const isActive = type === 'mouseenter';

    setNavActive(isActive);
    setNavHeight(value);
  };

  const handleClick = () => {
    setNavActive(!navActive);
  };

  const navigate = event => {
    if (event.target.className === 'internal-link') {
      event.preventDefault();
      const link = event.target.getAttribute('href');
      history.push(link);
    }
  };

  return (
    <main className={`${styles.wrapper} ${isMobile || isTablet ? styles.touch : ''}`}>
      <header className={styles.header}>
        <Nav
          action={handleAction}
          disable={disable}
          navActive={navActive}
          setPosition={setPosition}
        />
      </header>
      <section style={{ ...defaultStyle, ...currentStyle }} className={styles.content}>
        <div className={styles.shadow}>
          {isTouch && <MobileNavButton active={navActive} click={handleClick} />}
          <div
            onClick={navigate}
            className={isInspirationGallery ? styles.noScroll : styles.scroll}>
            {showForm && (
              <EmailCaptureCloud
                onClose={() => {
                  setShowForm(false);
                  localStorage.setItem('emailFormState', 'closed');
                }}
                maxYBound={window.innerHeight - footerHeight - contentTop}
              />
            )}
            {children}
          </div>
        </div>
      </section>
      {!hideFooter && <Footer ref={footerRef} footerColor={footerColor} />}
    </main>
  );
};

NavExpander.propTypes = {
  children: PropTypes.element.isRequired,
  disable: PropTypes.bool,
  history: PropTypes.object,
  location: PropTypes.object,
  isInspirationGallery: PropTypes.bool,
  hideFooter: PropTypes.bool,
  footerColor: PropTypes.string,
};

export default withRouter(NavExpander);
